import React, { useEffect, useRef } from "react";
import Sidebar from "../Sidebar/sidebar";
import GGABtn from "./ggaBtn";
const ToggleNavbar = ({ onClose, ggaEnabled, handleGGANav }) => {
  const modalRef = useRef(null);
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="fixed bg-cyber-bg/90 flex z-50 top-0 left-0 max-h-screen overflow-y-auto">
      <div
        ref={modalRef}
        className="relative bg-cyber-bg border-r border-cyber-dim top-0 rounded-lg w-full h-full flex flex-col p-2"
      >
        <button
          className="absolute top-1 right-4 text-3xl text-cyber-sub hover:text-cyber-accent z-50"
          onClick={onClose}
        >
          &times;
        </button>
        <div className="flex items-center flex-col gap-1 mt-6">
          <Sidebar isOpen={true} initialGameProgressToggle={false} />
        </div>
      </div>
    </div>
  );
};
export default ToggleNavbar;
